import {Alert, Badge, Button, Container, Modal, Table} from "react-bootstrap";
import TopMenu from "../components/topMenu";
import {useEffect, useState} from "react";
import axios from "axios";
import Helper from "../helper";
import {NotificationManager} from "react-notifications";

const SendCCPE = () => {

    const [courses, setCourses] = useState();
    const [show, setShow] = useState();
    const [completions, setCompletions] = useState();
    const [currentCourse, setCurrentCourse] = useState();
    const [ccpeState, setCcpeState] = useState();

    useEffect(() => {
        axios.get(Helper.URI('get-courses')).then(res => {
            setCourses(res.data);
        })
    }, [])

    const handleClose = () => {
        setCcpeState(void 0);
        setShow(false);
    };
    const handleShow = course => {
        setCurrentCourse(course);
        axios.get(Helper.URI('get-completion-status&course_id=' + course.id)).then(res => {
            if (res.data.error) {
                NotificationManager.error(res.data.error);
            } else {
                setCompletions(res.data);
                setShow(true);
            }
        })
    };

    const sendCCPE = () => {
        axios.post(Helper.URI('send-ccpe'), {course: currentCourse}).then(res => {
            if (res.data.error) {
                NotificationManager.error(res.data.error);
            } else {
                NotificationManager.success('Successfully');
                setCcpeState(res.data);
            }
        });
    }

    return <div>
        <TopMenu title="CCPE Sender"/>
        <Container>
            <Table striped>
                <thead>
                <tr>
                    <th>Course</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                {courses?.map(c =>
                    <tr key={c.id}>
                        <td>
                            <div>{c?.shortname}</div>
                            <>{c?.customfields?.map(f =>
                                <div key={f.name}>{f.name} : {f.value ? f.value : '-'}</div>
                            )}
                            </>
                        </td>
                        <td><Button variant='primary' onClick={handleShow.bind(this, c)}>CCPE</Button></td>
                    </tr>
                )}
                </tbody>
            </Table>
        </Container>
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Completion Viewer</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {ccpeState &&
                    <>
                        <div>conference_code: {ccpeState?.conference_code}</div>
                        <div>section_no: {ccpeState?.section_no}</div>
                        <Table>
                            <thead>
                                <tr>
                                    <th>license_id</th>
                                    <th>remark</th>
                                    <th>status</th>
                                </tr>
                            </thead>
                            {ccpeState?.person.map(u =>
                                <tr key={u.license_id}>
                                    <td>{u.license_id}</td>
                                    <td>{u.remark}</td>
                                    <td>{u.status=='fail'?<Badge style={{fontWeight:400}} bg="danger">{u.status}</Badge>:<Badge style={{fontWeight:400}} bg="success">{u.status}</Badge>}</td>
                                </tr>
                            )}
                        </Table>
                        <hr/>
                    </>
                }
                {Array.isArray(completions)?
                    <Table>
                        <thead>
                        <tr>
                            <th>License ID</th>
                            <th>Fullname</th>
                            <th>Course state</th>
                        </tr>
                        </thead>
                        <tbody>
                        {Array.isArray(completions) && completions?.map((c,i) => {
                            return <tr key={i}>
                                <td>{c.userDetail.username}</td>
                                <td>{c.user.fullname}</td>
                                <td>{c.completed ? <Badge style={{fontWeight: 400}} bg="success">Pass</Badge> :
                                    <Badge style={{fontWeight: 400}} bg="warning">Pending..</Badge>}</td>
                            </tr>
                        })}
                        </tbody>
                    </Table>
                    :
                    <Alert>No user enrol in this course.</Alert>
                }


            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={sendCCPE.bind(this)}>
                    Send
                </Button>
            </Modal.Footer>
        </Modal>
    </div>
}
export default SendCCPE;
